import {
  getDefaultStatisticItem
} from '../../utils/utils'

export default {
  statisticScheme: {
    'TOUCHDOWN': getDefaultStatisticItem('nfl.touchdown'),
    'GOAL': getDefaultStatisticItem('nfl.extra_point'),
    'TWO_POINTS_DOWN': getDefaultStatisticItem('nfl.two_points_down'),
    'FIELD_GOAL': getDefaultStatisticItem('nfl.field.goal'),
    'SAFETY': getDefaultStatisticItem('nfl.safety')
  },
  statisticEvents: {
    'TOUCHDOWN': 'TOUCHDOWN',
    'GOAL': 'GOAL',
    'TWO_POINTS_DOWN': 'YES',
    'FIELD_GOAL': 'FIELD_GOAL',
    'SAFETY': 'SAFETY'
  },
  statisticOrder: [
    'TOUCHDOWN',
    'GOAL',
    'TWO_POINTS_DOWN',
    'FIELD_GOAL',
    'SAFETY'
  ]
}
